import { Routes } from '@angular/router';
import { authGuard } from './core/gaurds/auth.guard';
import { checkoutGuard, collectionGuard, itemDetailsGuard } from './core/gaurds/booking.guard';

export const routes: Routes = [
  {
    // New homepage (concept3 rebuild) is now the default landing page.
    path: '',
    loadComponent: () => import('./pages/home-v2/home-v2').then((m) => m.HomeV2),
  },
  // {
  //   // Keep the new homepage reachable at its original preview path too.
  //   path: 'home-v2',
  //   loadComponent: () => import('./pages/home-v2/home-v2').then((m) => m.HomeV2),
  // },
  // // {
  // //   // Previous homepage, retained and reachable while the new one beds in.
  // //   path: 'home-old',
  // //   loadComponent: () => import('./pages/home/home').then((m) => m.Home),
  // // },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./features/contact-us/pages/contact-us-page/contact-us-page').then(
        (m) => m.ContactUsPage,
      ),
  },
  {
    path: 'item-enquiry',
    loadComponent: () =>
      import('./features/item-enquiry/pages/item-enquiry-page/item-enquiry-page').then(
        (m) => m.ItemEnquiryPage,
      ),
  },
  {
    path: 'coverage',
    loadComponent: () =>
      import('./features/coverage/pages/coverage-page/coverage-page').then((m) => m.CoveragePage),
  },
  {
    path: 'faqs',
    loadComponent: () =>
      import('./features/faqs/pages/faqs-page/faqs-page').then((m) => m.FaqsPage),
  },
  {
    path: 'track',
    loadComponent: () =>
      import('./features/track/pages/track-page/track-page').then((m) => m.TrackPage),
  },
  {
    path: 'help',
    loadComponent: () =>
      import('./features/help/pages/help-page/help-page').then((m) => m.HelpPage),
  },
  {
    path: 'how-it-works',
    loadComponent: () =>
      import('./features/how-it-works/pages/how-it-works-page/how-it-works-page').then(
        (m) => m.HowItWorksPage,
      ),
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./features/about/pages/about-page/about-page').then((m) => m.AboutPage),
  },
  // Legal pages share one component; `doc` picks the content.
  {
    path: 'terms',
    data: { doc: 'terms' },
    loadComponent: () =>
      import('./features/legal/pages/legal-page/legal-page').then((m) => m.LegalPage),
  },
  {
    path: 'privacy',
    data: { doc: 'privacy' },
    loadComponent: () =>
      import('./features/legal/pages/legal-page/legal-page').then((m) => m.LegalPage),
  },
  {
    path: 'cookies',
    data: { doc: 'cookies' },
    loadComponent: () =>
      import('./features/legal/pages/legal-page/legal-page').then((m) => m.LegalPage),
  },
  {
    path: 'reviews',
    loadComponent: () =>
      import('./features/reviews/pages/reviews-page/reviews-page').then((m) => m.ReviewsPage),
  },
  // Index before :slug, or 'blog' would be read as an article slug.
  {
    path: 'blog',
    loadComponent: () =>
      import('./features/blog/pages/blog-page/blog-page').then((m) => m.BlogPage),
  },
  {
    path: 'blog/:slug',
    loadComponent: () =>
      import('./features/blog/pages/blog-post-page/blog-post-page').then((m) => m.BlogPostPage),
  },
  {
    path: 'delivery-request',
    canActivate: [itemDetailsGuard],
    loadComponent: () =>
      import('./features/delivery-request/pages/delivery-request-page/delivery-request-page').then(
        (m) => m.DeliveryRequestPage,
      ),
  },
  {
    path: 'add-to-cart',
    // canActivate: [authGuard],
    loadComponent: () =>
      import('./features/add-to-cart/pages/add-to-cart-page/add-to-cart-page').then(
        (m) => m.AddToCartPage,
      ),
  },
  {
    path: 'checkout',
    canActivate: [authGuard, checkoutGuard],
    loadComponent: () =>
      import('./features/checkout/pages/checkout-page/checkout-page').then((m) => m.CheckoutPage),
  },
  {
    path: 'address-details',
    canActivate: [collectionGuard],
    loadComponent: () =>
      import('./features/address-details/pages/address-details-page/address-details-page').then(
        (m) => m.AddressDetailsPage,
      ),
  },
  {
    path: 'account-settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/account-settings/pages/account-setting-page/account-setting-page').then(
        (m) => m.AccountSettingPage,
      ),
  },
  {
    path: 'orders',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/orders/pages/order-page/order-page').then((m) => m.OrderPage),
  },
  {
    path: 'orders/:orderId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/orders/pages/order-page/order-page').then((m) => m.OrderPage),
  },
  // {
  //   path: 'coming-soon',
  //   loadComponent: () =>
  //     import('./pages/coming-soon/coming-soon').then((m) => m.ComingSoon),
  // },
  { path: '**', redirectTo: '' },
];
